<template>
    <div style="display: flex; flex-direction: column;">
        <MercenaryHeader :title="'다이렉트 메시지'" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div style="padding: 0 12px;">
            <div style="display: flex; justify-content: center; align-items: center; gap: 4px; margin-top: 8px; position: sticky; top: 0; background-color: #fff; padding: 8px 0; z-index: 5;">
                <div @click="setTopBtn(BTN_TYPE.INTEREST)" style="display: flex; align-items: center; gap: 4px;" :style="{ color: curType === BTN_TYPE.INTEREST ? '#fff' : '#808080', backgroundColor: curType === BTN_TYPE.INTEREST ? '#210f03' : '' }" class="top_btn">
                    <div>
                        <img style="width: 16px;" :src="require('@/assets/img/interest_star.png')" alt="">
                    </div>
                    <div>관심 프로필</div>
                </div>
                <div @click="setTopBtn(BTN_TYPE.RECENT)" :style="{ color: curType === BTN_TYPE.RECENT ? '#fff' : '#808080', backgroundColor: curType === BTN_TYPE.RECENT ? '#210f03' : '' }" class="top_btn">최근 본 프로필</div>
            </div>
            <div style="margin-top: 12px;">
                <div>
                    <input placeholder="검색" style="width: 100%; border: none; background-color: #f5f5f5; padding: 10px; border-radius: 12px; outline: none;" type="text">
                </div>
            </div>
        </div>
        <InfinityScroll :refresh-action="refresh" :handleNextPage="handleNextPage" :isEnableNextPageHandle="isEnableNextPageHandle" style="flex: 1; padding: 12px;">
            <div v-for="each, i in members" :key="i">
                <div @click="sendDirectMessage(each.member); $Util.sendEventClick('다이렉트메시지_메시지보내기')" v-if="each.member" style="display: flex; gap: 8px; align-items: center; margin-bottom: 24px;">
                    <div>
                        <ProfileImage style="width: 40px" :imagePath="each.member.image_path"></ProfileImage>
                    </div>
                    <div style="font-size: 14px; font-weight: 700;">{{ each.member.nic_name }} <span style="font-weight: 500; color: var(--color-main);">{{ each.member.position }}</span></div>
                </div>
            </div>
        </InfinityScroll>
    </div>
</template>

<script>
const BTN_TYPE = {
    INTEREST: 'INTEREST',
    RECENT: 'RECENT'
}

import MercenaryHeader from '@/components/common/MercenaryHeader'
import InfinityScroll from '@/components/common/InfinityScroll'
import ProfileImage from '@/components/common/ProfileImage'

export default {
    name: 'DirectMessageList',
    components: { MercenaryHeader, InfinityScroll, ProfileImage },
    data() {
        return {
            curType: BTN_TYPE.INTEREST,
            BTN_TYPE: BTN_TYPE,
            interestPage: 1,
            recentPage: 1,
            isEnableNextPageHandle: true,
            members: [],
        }
    },
    created() {
        this.getInterestProfileList()
    },
    methods: {
        setTopBtn(type) {
            this.curType = type
            this.members = []
            if (this.curType === BTN_TYPE.INTEREST) {
                this.getInterestProfileList()
            } else {
                this.getRecentProfileList()
            }
        },
        async getInterestProfileList() {
            this.isEnableNextPageHandle = false

            const parameters = {}
            parameters.page = this.interestPage

            const res = await this.$Axios.get('/api/like/member/list', { params: parameters })
            const interestMembers = res.data.members

            if (interestMembers.length > 0) {
                this.isEnableNextPageHandle = true
                this.members = [...this.members, ...interestMembers]
            }
        },
        async getRecentProfileList() {
            this.isEnableNextPageHandle = false

            const parameters = {}
            parameters.page = this.recentPage

            const res = await this.$Axios.get('/api/like/visit/list', { params: parameters })
            const recentMembers = res.data.members

            if (recentMembers.length > 0) {
                this.isEnableNextPageHandle = true
                this.members = [...this.members, ...recentMembers]
            }
        },
        refresh() {

        },
        handleNextPage() {
            this.recentPage++
            this.getRecentProfileList()
        },
        async sendDirectMessage(member) {
            await this.$Util.showDirectMessageSenderForm({ memberInfo: member, isDirectUser: true });
        }
    }

}
</script>

<style scoped>
.top_btn {
    padding: 0 12px;
    height: 40px;
    border-radius: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
}
</style>